import { Productbtn } from "../../../../../../shared/services/interfacev2";

interface CartActionsParams {
  selectedProductslist: Productbtn[];
  setSelectedProductslist: React.Dispatch<React.SetStateAction<Productbtn[]>>;
  setValueMap: React.Dispatch<React.SetStateAction<{ [id: string]: number }>>;
  setCondition: React.Dispatch<React.SetStateAction<number>>;
  setEditedAmounts?: React.Dispatch<React.SetStateAction<{ [productId: string]: string }>>;
  editedAmounts?: { [productId: string]: string };
}

export const useCartActions = ({ setSelectedProductslist, setValueMap, setCondition, setEditedAmounts }: CartActionsParams) => {
  // Add product
  const addProductToCart = (product: Productbtn) => {
    const productId = product._id.$oid;
    const key = `${productId}-${product.amount}`;

    setValueMap((prev) => ({
      ...prev,
      [key]: (prev[key] ?? 0) + 1,
    }));

    setSelectedProductslist((prev) => {
      const exists = prev.some((item) => item._id.$oid === productId && item.amount === product.amount);

      return exists ? prev : [...prev, product];
    });
  };

  // Remove product completely
  const removeProductFromCart = (productId: string, amount: string) => {
    const key = `${productId}-${amount}`;

    setValueMap((prev) => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });

    setSelectedProductslist((prev) => {
      const remainingProducts = prev.filter((product) => !(product._id.$oid === productId && product.amount === amount));

      const stillExists = remainingProducts.some((product) => product._id.$oid === productId);

      if (!stillExists) {
        setEditedAmounts?.((previous) => {
          const updated = { ...previous };
          delete updated[productId];
          return updated;
        });
      }

      return remainingProducts;
    });
  };

  // Update quantity
  const updateQuantity = (productId: string, amount: string, type: "add" | "subtract") => {
    const key = `${productId}-${amount}`;

    setValueMap((prev) => {
      const currentQuantity = prev[key] ?? 0;

      const newQuantity = type === "add" ? currentQuantity + 1 : Math.max(0, currentQuantity - 1);

      if (newQuantity === 0) {
        const updated = { ...prev };
        delete updated[key];

        setSelectedProductslist((products) => {
          const remaining = products.filter((product) => !(product._id.$oid === productId && product.amount === amount));

          if (!remaining.some((p) => p._id.$oid === productId)) {
            setEditedAmounts?.((previous) => {
              const updatedAmounts = { ...previous };
              delete updatedAmounts[productId];
              return updatedAmounts;
            });
          }

          return remaining;
        });

        return updated;
      }

      return {
        ...prev,
        [key]: newQuantity,
      };
    });
  };

  return {
    addProductToCart,
    removeProductFromCart,
    updateQuantity,
  };
};
